import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/dashboards`;

export const listDashboards = (wsId) => apiClient.get(base(wsId));
export const getDashboard = (wsId, id) => apiClient.get(`${base(wsId)}/${id}`);
export const createDashboard = (wsId, dto) => apiClient.post(base(wsId), dto);
export const updateDashboard = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/${id}`, dto);
export const deleteDashboard = (wsId, id) => apiClient.del(`${base(wsId)}/${id}`);
export const addWidget = (wsId, dashId, dto) => apiClient.post(`${base(wsId)}/${dashId}/widgets`, dto);
export const updateWidget = (wsId, dashId, wId, dto) => apiClient.patch(`${base(wsId)}/${dashId}/widgets/${wId}`, dto);
export const removeWidget = (wsId, dashId, wId) => apiClient.del(`${base(wsId)}/${dashId}/widgets/${wId}`);

export const listTabs   = (wsId, dashId) => apiClient.get(`${base(wsId)}/${dashId}/tabs`);
export const createTab  = (wsId, dashId, dto) => apiClient.post(`${base(wsId)}/${dashId}/tabs`, dto);
export const updateTab  = (wsId, dashId, tabId, dto) => apiClient.patch(`${base(wsId)}/${dashId}/tabs/${tabId}`, dto);
export const deleteTab  = (wsId, dashId, tabId) => apiClient.del(`${base(wsId)}/${dashId}/tabs/${tabId}`);
